<template>
  <nx-dialog
    :visible.sync="show"
    title="消息流水号信息"
    width="1050px"
    :before-close="beforeClose"
    :show-btn="true"
    :canHideFoot = "false"
    v-if="show"
  >
    <div style="font-size: 15px; margin-top: 15px; margin-left: 15px">{{ '消息流水号:' + this.seriNo }}</div>
    <nx-table ref="nxTable" :data="tableData" table-title="诊断记录" @search="search">
      <el-table-column label="指令类型" prop="commandType" >
        <template v-slot="{ row }">
          {{ (udsConmondTypes.find((item) => item.value === row.commandType) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column label="诊断项" prop="udsItem" >
        <template v-slot="{ row }">
          {{ (udsItemTypes.find((item) => item.value === row.udsItem) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column label="请求CAN_ID" prop="wrappedRequestCanId" />
      <el-table-column label="请求CAN_ID详情" prop="wrappedRequestCanId" >
        <template v-slot="{ row }">
          {{ 'CAN总线请求ID:' + row.requestCanId }}
          <br />
          {{
            '数据采集方式:' +
            (collectMethodTypes.find((item) => item.value === row.requestFrameType) || {}).label
          }}
          <br />
          {{ '桢类型:' + (frameTypes.find((item) => item.value === row.requestFrameType) || {}).label }}
          <br />
          {{ 'CAN通道号:' + (canTypes.find((item) => item.value === row.requestChannelId) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column label="反馈CAN_ID" prop="wrappedResponseCanId"  />
      <el-table-column label="反馈CAN_ID详情" prop="wrappedRequestCanId" >
        <template v-slot="{ row }">
          {{ 'CAN总线请求ID:' + row.responseCanId }}
          <br />
          {{
            '数据采集方式:' +
            (collectMethodTypes.find((item) => item.value === row.responseCollectMethod) || {}.label)
          }}
          <br />
          {{ '桢类型:' + (frameTypes.find((item) => item.value === row.responseFrameType) || {}).label }}
          <br />
          {{
            'CAN通道号:' + (canTypes.find((item) => item.value === row.responseChannelId) || {}.label)
          }}
        </template>
      </el-table-column>
    </nx-table>
  </nx-dialog>
</template>
<script>
import {
  fileStatusArr,
  powerTypes,
  responseResultsTypes,
  udsConmondTypes,
  udsItemTypes,
  collectMethodTypes,
  frameTypes,
  canTypes,
  // vehiclePurposeTypes
} from '../../config.js';

import { getUdsCheckList, exportUdsItemList, getUdsCheckDetials } from '@/api/dataService/udsV2.js';
export default {
  props: {
    visible: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: [String,Number],
      default: '',
    },
    seriNo: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      udsConmondTypes,
      collectMethodTypes,
      udsItemTypes,
      frameTypes,
      showSb: false,
      canTypes,
      show: false,
      tableData: [],
    };
  },
  computed: {},
  watch: {
    id: {
      handler(id) {
        if (id) this.getDetail(id);
      },
    },
    visible: {
      handler(visible) {
        this.show = visible;
            if (visible) {
            
        }
      },
    },
    show: {
      handler(show) {
        this.$emit('update:visible', show);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    async onConfirm() {
      this.show = false;
      this.$emit('onConfirm', params);
    },
    beforeClose(done) {
      // this.$refs.submitForm.resetFields();
      this.tableData = [];
      done();
    },
    async getDetail(id) {
      if (this.show) {
        this.$refs.nxTable.search(1);
      }
      
    },
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      let params = { udsTaskId: this.id, pageNum, pageSize };
      const { data } = await getUdsCheckList(params);
      this.tableData = data.list;
      pagination.total = data.total;
    },
  },
};
</script>
<style scoped lang="scss"></style>
